
export class NormalizeUrl
{
    public static Normalize(url: string): string
    {
        return url.toLowerCase()
            .replaceAll(" ", "-")
            .replaceAll("ą", "a")
            .replaceAll("ę", "e")
            .replaceAll("ć", "c")
            .replaceAll("ł", "l")
            .replaceAll("ń", "n")
            .replaceAll("ó", "o")
            .replaceAll("ś", "s")
            .replaceAll("ź", "z")
            .replaceAll("ż", "z");
    }
}
